import { TextField, type TextFieldProps } from "@mui/material";
import { isEmpty } from "lodash-es";
import { type FC, useMemo, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AutoCompleteSelector } from "../../../../generic/components/auto-complete/auto-complete";
import type { TagGroup } from "../../../../merge-tag/components/types";
import type { EditorLinkData } from "../../plugins/toolbar/hooks/use-link-button-on-click";
import { getCleanUrl } from "../utils/get-clean-url";
import type { Link } from "./types";

export const LinkUrlField: FC<{
  filterTags: (x: string) => TagGroup;
  type: EditorLinkData["type"];
  disabled?: boolean;
}> = ({ filterTags, disabled, type }) => {
  const {
    control,
    formState: { defaultValues, errors },
  } = useFormContext<Link>();

  const defaultUrl = useMemo(() => makeDefaultUrl(defaultValues?.url), [defaultValues]);

  const [controlledUrl, setControlledUrl] = useState(defaultUrl);

  if (!["range", "asset", "image"].includes(type)) return null;

  return (
    <Controller
      name="url"
      control={control}
      render={({ field }) => (
        <AutoCompleteSelector
          defaultValue={defaultUrl}
          onChange={(value) => {
            const clean = getCleanUrl(value);
            setControlledUrl(clean);
            field.onChange(clean);
          }}
          filterTags={filterTags}
          renderInput={(params: TextFieldProps) => (
            <TextField
              {...params}
              value={controlledUrl}
              id="link-url"
              label="Link"
              placeholder="Link"
              error={Boolean(errors?.url?.message)}
              helperText={errors?.url?.message}
              disabled={type === "asset" || disabled}
              fullWidth
            />
          )}
        />
      )}
    />
  );
};

function makeDefaultUrl(url?: string): string {
  return isEmpty(url) ? "https://" : url!;
}
